import { ArrowUpRight } from "lucide-react";

const SIZES = {
  sm: "h-9 px-4 text-xs",
  md: "h-11 px-6 text-sm",
  lg: "h-14 px-8 text-base",
};

const VARIANTS = {
  solid: "bg-brand text-white shadow-ambient hover:bg-[rgb(0_40_140)]",
  ink: "bg-ink text-white hover:bg-black",
  outline: "border border-ink/15 bg-white/80 text-ink hover:border-brand hover:text-brand",
  accent: "bg-accent text-white hover:bg-[rgb(42_103_137)]",
  glass: "border border-white/25 bg-white/10 text-white backdrop-blur-md hover:bg-white/20",
};

export default function AppButton({ app, variant = "solid", size = "md", testid, className = "" }) {
  return (
    <a
      href={app.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={`inline-flex items-center justify-center gap-1.5 rounded-full font-semibold transition-all duration-200 hover:-translate-y-px active:translate-y-0 ${SIZES[size]} ${VARIANTS[variant]} ${className}`}
    >
      {app.name}
      <ArrowUpRight className="h-4 w-4" strokeWidth={2.4} aria-hidden="true" />
    </a>
  );
}
